import {StageLayer} from "@nolimit/slot-launcher/bin/StageLayer";
import {gsap, TweenLite} from "gsap";
import {ContinueButton} from "@nolimit/slot-launcher/bin/gui/buttons/concretebuttons/ContinueButton";
import {FITH2SoundManager} from "../sound/FITH2SoundManager";
import {FITH2SoundConfig} from "../configs/FITH2SoundConfig";
import {FireInTheHole2} from "../FireInTheHole2";
import {ScatterCounter} from "./ScatterCounter";
import {SpineTween} from "@nolimit/slot-game/bin/animation/SpineTween";
import {NolimitApplication} from "@nolimit/slot-launcher/bin/NolimitApplication";
import {BitmapText} from "pixi.js";
import {FITH2GameAssets} from "../FITH2GameAssets";
import {FITH2Scatter} from "../symbols/FITH2Scatter";

export class FITH2FreespinIntro extends PIXI.Container implements StageLayer {
    private _spine: PIXI.spine.Spine | null;
    private _spineContainer: PIXI.Sprite;
    private _button: ContinueButton;
    private _spins: BitmapText | null;
    private _clickCallback: () => void;

    constructor() {
        super();
        this.name = "FreespinIntro";
        this.init();
    }

    private onButtonClick(playClickSound: boolean): void {
        if (playClickSound) {
            FITH2SoundManager.playSound(FITH2SoundConfig.CONTINUE_BUTTON);
        }
        const hideFSIntroTL = gsap.timeline();

        hideFSIntroTL.add([
            FireInTheHole2.reelFrame.hide(),
            gsap.to(this._button, 0.2, {alpha: 0}),
            () => {
                this._button.enable(false);
            }
        ]);
        hideFSIntroTL.add([
            new SpineTween(this._spine!, 0, "out"),
            () => {
                FITH2SoundManager.playSound("fsIntroWagonOut");
                FITH2SoundManager.playAmbientLoop(0.1, `fs${FireInTheHole2.model.data.scatterCount === 3 ? "1" : "2"}`);
                this._button.enable(false);
                this._clickCallback();
                this._clickCallback = () => {
                };
            }
        ], 0);

        hideFSIntroTL.add(() => {
            this.visible = false;
            FireInTheHole2.gameViewContainer.removeDimmer();
            this._spineContainer.removeChildren();

            if (this._spins) {
                this._spins!.destroy();
                this._spins = null;
            }
        });
    }

    public onResize(): void {
        if (!this.visible) {
            return;
        }
        if (NolimitApplication.isLandscape) {
            this._button.position.set(360, 588);
            return;
        }
        this._button.position.set(360, Math.max(530, NolimitApplication.screenBounds.bottom - 210));
    }

    private init(): void {
        this._spineContainer = new PIXI.Sprite();
        this.addChild(this._spineContainer);
        this._spineContainer.position.set(360, 360);
        this._button = new ContinueButton();
        this._button.addClickCallback(() => this.onButtonClick(true));
        this._button.position.set(360, 530);
        this._button.pivot.set(this._button.width * 0.5, 0);
        this._button.enable(false);
        this._button.alpha = 0;
        this.addChild(this._button);
        this.visible = false;
    }

    public show(callback: () => void, isReplay: boolean = false): gsap.core.Timeline {
        const tl = gsap.timeline();
        FireInTheHole2.xBetController.buttonsVisible = false;
        this._button.alpha = 0;
        if (this._spine) {
            this._spine.destroy();
            this._spine = null;
        }
        this._spine = new PIXI.spine.Spine(FireInTheHole2.assetLoader.getSpineAsset("FS_Intro"));
        this._spineContainer.addChild(this._spine);

        this._spins = new BitmapText("22", {
            fontName: FITH2GameAssets.BITMAP_FONT_FS_SPINS,
            fontSize: 40
        });
        this._spins.visible = false;
        this._spins.text = `${FireInTheHole2.model.data.freespinsLeft}`;
        this._spins.letterSpacing = 2;
        this._spins.position.set(360 - this._spins.width * 0.5, 155);
        this._spins!.alpha = 0;
        //this.addChild(this._spins);

        tl.add(() => {
            this._clickCallback = callback;
        });

        if (FireInTheHole2.model.gameData && FireInTheHole2.model.gameData.brokeTheBank) {
            this.onButtonClick(false);
        } else {
            if (FireInTheHole2.model.freespinTriggeredThisSpin) {
                tl.add(() => FITH2SoundManager.playSound("scatterFlash"), 0);
                ScatterCounter.allScatters.forEach((scatter: FITH2Scatter) => {
                    tl.add(scatter.playWin(), 0);
                });
            }

            tl.add([
                () => {
                    this._spins!.visible = true;
                    this.visible = true;
                    this.onResize();
                    this.alpha = 1;
                    FITH2SoundManager.playFSIntroSound();
                    FireInTheHole2.keypadPlugin.hide();

                },
                FireInTheHole2.gameViewContainer.addDimmer(false),
                new SpineTween(this._spine, 0, "in")
            ]);
            tl.add([
                TweenLite.to(this._button, 0.2, {alpha: 1}),
                () => {
                    this._spine!.state.setAnimation(0, "base", true);
                    ScatterCounter.reset();

                }
            ]).add(() => {
                this._button.enable(true);
            });
        }
        return tl;
    }
}